import type {
  CountrySwitch,
  CountrySwitch_SelectedShop,
  CountrySwitch_LanguageSelection,
  CountrySwitch_LanguageSelection_Language,
  CountrySwitch_CountryItem,
} from "../../aysa_api/models/country_switch.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseImage,
  encodeImage,
  decodeImage,
} from "../../aysa_api/models/image";
import {
  createBaseLinkTarget,
  encodeLinkTarget,
  decodeLinkTarget,
} from "../../aysa_api/models/link_target";

export const createBaseCountrySwitch = (): CountrySwitch => {
  return {
    selectedShop: createBaseCountrySwitch_SelectedShop(),

    countries: [],
  };
};

export const decodeCountrySwitch = (
  reader: Reader,
  length: number
): CountrySwitch => {
  const end = reader.pos + length;
  const message = createBaseCountrySwitch();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.selectedShop = decodeCountrySwitch_SelectedShop(
          reader,
          reader.uint32()
        );

        break;
      case 2:
        message.languageSelection = decodeCountrySwitch_LanguageSelection(
          reader,
          reader.uint32()
        );

        break;
      case 3:
        message.countries.push(
          decodeCountrySwitch_CountryItem(reader, reader.uint32())
        );

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCountrySwitch = (
  writer: Writer,
  message: CountrySwitch
): Writer => {
  encodeCountrySwitch_SelectedShop(
    writer.uint32(10).fork(),
    message.selectedShop
  ).ldelim();
  if (message.languageSelection !== undefined) {
    encodeCountrySwitch_LanguageSelection(
      writer.uint32(18).fork(),
      message.languageSelection
    ).ldelim();
  }
  for (const value of message.countries) {
    encodeCountrySwitch_CountryItem(writer.uint32(26).fork(), value).ldelim();
  }

  return writer;
};

export const createBaseCountrySwitch_SelectedShop =
  (): CountrySwitch_SelectedShop => {
    return {
      flag: createBaseImage(),
    };
  };

export const decodeCountrySwitch_SelectedShop = (
  reader: Reader,
  length: number
): CountrySwitch_SelectedShop => {
  const end = reader.pos + length;
  const message = createBaseCountrySwitch_SelectedShop();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.flag = decodeImage(reader, reader.uint32());

        break;
      case 2:
        message.countryLabel = reader.string();

        break;
      case 3:
        message.languageLabel = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCountrySwitch_SelectedShop = (
  writer: Writer,
  message: CountrySwitch_SelectedShop
): Writer => {
  encodeImage(writer.uint32(10).fork(), message.flag).ldelim();
  if (message.countryLabel !== undefined) {
    writer.uint32(18).string(message.countryLabel);
  }
  if (message.languageLabel !== undefined) {
    writer.uint32(26).string(message.languageLabel);
  }

  return writer;
};

export const createBaseCountrySwitch_LanguageSelection =
  (): CountrySwitch_LanguageSelection => {
    return {
      languages: [],
    };
  };

export const decodeCountrySwitch_LanguageSelection = (
  reader: Reader,
  length: number
): CountrySwitch_LanguageSelection => {
  const end = reader.pos + length;
  const message = createBaseCountrySwitch_LanguageSelection();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.languages.push(
          decodeCountrySwitch_LanguageSelection_Language(
            reader,
            reader.uint32()
          )
        );

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCountrySwitch_LanguageSelection = (
  writer: Writer,
  message: CountrySwitch_LanguageSelection
): Writer => {
  for (const value of message.languages) {
    encodeCountrySwitch_LanguageSelection_Language(
      writer.uint32(10).fork(),
      value
    ).ldelim();
  }

  return writer;
};

export const createBaseCountrySwitch_LanguageSelection_Language =
  (): CountrySwitch_LanguageSelection_Language => {
    return {
      label: "",
      link: createBaseLinkTarget(),
      isSelected: false,
    };
  };

export const decodeCountrySwitch_LanguageSelection_Language = (
  reader: Reader,
  length: number
): CountrySwitch_LanguageSelection_Language => {
  const end = reader.pos + length;
  const message = createBaseCountrySwitch_LanguageSelection_Language();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.label = reader.string();

        break;
      case 2:
        message.link = decodeLinkTarget(reader, reader.uint32());

        break;
      case 3:
        message.isSelected = reader.bool();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCountrySwitch_LanguageSelection_Language = (
  writer: Writer,
  message: CountrySwitch_LanguageSelection_Language
): Writer => {
  writer.uint32(10).string(message.label);
  encodeLinkTarget(writer.uint32(18).fork(), message.link).ldelim();
  writer.uint32(24).bool(message.isSelected);

  return writer;
};

export const createBaseCountrySwitch_CountryItem =
  (): CountrySwitch_CountryItem => {
    return {
      flag: createBaseImage(),
      countryName: "",
      link: createBaseLinkTarget(),
      isCurrentCountry: false,
    };
  };

export const decodeCountrySwitch_CountryItem = (
  reader: Reader,
  length: number
): CountrySwitch_CountryItem => {
  const end = reader.pos + length;
  const message = createBaseCountrySwitch_CountryItem();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.flag = decodeImage(reader, reader.uint32());

        break;
      case 2:
        message.countryName = reader.string();

        break;
      case 3:
        message.link = decodeLinkTarget(reader, reader.uint32());

        break;
      case 4:
        message.isCurrentCountry = reader.bool();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCountrySwitch_CountryItem = (
  writer: Writer,
  message: CountrySwitch_CountryItem
): Writer => {
  encodeImage(writer.uint32(10).fork(), message.flag).ldelim();
  writer.uint32(18).string(message.countryName);
  encodeLinkTarget(writer.uint32(26).fork(), message.link).ldelim();
  writer.uint32(32).bool(message.isCurrentCountry);

  return writer;
};
